import { Model, User, YardTrip } from ".";

export default class YardTripDeliveryNote extends Model {
	get singularNoun() {
		return "trip delivery note";
	}

	get mutations() {
		return {
			trip: YardTrip,
			userVerifiedEIN: User,
			userVerifiedProductLoaded: User,
			userVerifiedProductMatch: User
		};
	}

	resource() {
		return "delivery-note";
	}
}
